import { useEffect, useState } from 'react'

export const useFetchOffers = ({ adapter, requestOffers, immOffers = {}, immDeposits, depositId, originCountry, flow = undefined, featureFlags = undefined }) => {
    const [parsedOffers, setParsedOffers] = useState([])

    const handleOffers = () => {
        if (!depositId) {
            return
        };
        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const countractNumber = immDeposit.getIn(['contract', 'contractNumber']);
        requestOffers({ contract: countractNumber, flow });
    }

    useEffect(() => {
        handleOffers();
    }, []);

    useEffect(() => {
        if (immOffers) {
            const offersSelected = immOffers && immOffers.get('offersSelected');
            if (offersSelected) {
                setParsedOffers(adapter({ offers: offersSelected ? offersSelected.get('offers') : [], originCountry, featureFlags, immDeposits }));
            }
        }
    }, [immOffers]);
    return {
        parsedOffers,
        refetchOffers: handleOffers,
        error: !!immOffers.getIn(['offersSelectedError']),
        loading: !!immOffers.getIn(['offersSelectedLoading'])
    }
}